import styled, { css } from 'styled-components';
import Popover from 'antd/es/popover';

export const SortingTabsWrapper = styled.div``;

export const SortingTabsPopover = styled(Popover)`
  .setur-popover-inner {
    border-radius: 8px;
    box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.12);
    padding: 0px;
  }
`;

export const SortingTabsPopoverContent = styled.div`
  min-width: 215px;
`;

export const SortingTabsItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  padding: 16px 24px;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;

  span:first-child {
    color: ${({ theme }) => theme.palette.grey1100};
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey200};
  }
`;

export const SortingTabsContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SortingTabsHeading = styled.h6`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 0px;
`;

export const SortingTabsActiveLabelButton = styled.div<{
  isOpen: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.palette.grey800};
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;

  span[data-role='custom-icon'] {
    transition: transform 0.2s ease-in-out;

    ${({ isOpen }) =>
      isOpen &&
      css`
        transform: rotate(180deg);
      `}
  }
`;
